import * as React from "react";
import Container from "./styled";
import { Link } from "react-scroll";
import { Fade } from "react-awesome-reveal";

export default function Beneficios() {
  return (
    <Container>
      <Fade delay={100} duration={800} triggerOnce={true}>
        {/* Title */}
        <h2>Beneficios de asegurar con nosotros</h2>
      </Fade>
      {/* Beneficios Container */}
      <div className="beneficiosContainer">
        <Fade delay={100} duration={800} triggerOnce={true}>
          {/* Beneficio 1 */}
          <div>
            <h3>Asistencia inmediata</h3>
            <p id="parrafoAsistencia">
              Nuestro servicio de atención al cliente 24/7 te garantiza
              tranquilidad y soluciones.
            </p>
          </div>
        </Fade>
        <Fade delay={100} duration={800} triggerOnce={true}>
          {/* Beneficio 2 */}
          <div>
            <h3>Asistencia especializada en siniestros</h3>
            <p>Te acompañamos en el momento del siniestro.</p>
          </div>
        </Fade>
        <Fade delay={100} duration={800} triggerOnce={true}>
          {/* Beneficio 3 */}
          <div>
            <h3>Toda una gama de descuentos y coberturas </h3>
            <p>
              Aprovechá los descuentos y elegí tu forma de pago preferida, ya
              sea con tarjeta o efectivo!
            </p>
          </div>
        </Fade>
        <h3 id="textComunicate">
          Comunicate a través de nuestras líneas telefónicas de 9 a 18 hs o
          resolvé tus dudas 24/7 con Sebi, nuestro asesor virtual.
        </h3>
      </div>
      {/* Cotizar Button */}
      <Fade delay={100} duration={800} triggerOnce={true}>
        <Link to="header" smooth={true} spy={true} duration={500}>
          ¡Cotizá tu bici!
        </Link>
      </Fade>
    </Container>
  );
}
